(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/shared-components/use-get-cms-data-document.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/shared-components/use-get-cms-data-document.js');

'use strict';

const {
  logger
} = svs.termsIntegrity;
const TirService = svs.termsIntegrity.sharedComponents.TirService;
const useGetCmsDataDocument = dataGid => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [dataError, setDataError] = React.useState(false);
  React.useEffect(() => {
    let isMounted = true;
    const getData = async () => {
      try {
        setLoading(true);
        const {
          error,
          totalCount,
          result
        } = await TirService.getCmsDataDocumentAsync(dataGid);
        if (isMounted) {
          logger.debug("useGetCmsDataDocument: error: ".concat(error, ", totalCount: ").concat(totalCount, ", result: ").concat(result));
          logger.debug(result);
          setLoading(false);
          if (error) {
            setDataError(true);
          } else if (result && result.length > 0) {
            setData(result);
          }
        }
      } catch (error) {
        if (isMounted) {
          setLoading(false);
          setDataError(true);
          logger.debug("useGetCmsDataDocument error:".concat(error));
        }
      }
    };

    getData();
    return () => {
      isMounted = false;
    };
  }, [dataGid]);
  return {
    data,
    loading,
    dataError
  };
};
svs.termsIntegrity.sharedComponents.useGetCmsDataDocument = useGetCmsDataDocument;

 })(window);